import { EntitySwitch, isComponentType } from "@backstage/plugin-catalog";

import defaultComponentPage from "./dataComponentPage";
import dataformRepositoryPage from "./dataformRepository";
import governanceServicePage from "./governanceService";
import serviceEntityPage from "./service";

export default (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType("gcp-dataform-repository")}>
      {dataformRepositoryPage}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isComponentType("governance-service")}>
      {governanceServicePage}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isComponentType("service")}>
      {serviceEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{defaultComponentPage}</EntitySwitch.Case>
  </EntitySwitch>
);
